// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 5476); hand-edits allowed (see docs/architecture.md)

/** `this.MISSION_WEAP_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_MISSION_WEAP_DEF(): any {
  return {
    "mission1": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "pistol": 3,
      "jet_pack": 1,
      "skip_go": 100
    },
    "mission2": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "uzi": 1,
      "skip_go": 100
    },
    "mission3": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "shotgun": 1,
      "skip_go": 100
    },
    "mission4": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "cluster_bomb": 3,
      "skip_go": 100
    },
    "mission5": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "minigun": 1,
      "skip_go": 100
    },
    "mission6": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "mine": 1,
      "skip_go": 100
    },
    "mission7": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "mortar": 1,
      "skip_go": 100
    },
    "mission8": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "mine": 1,
      "skip_go": 100
    },
    "mission9": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "dynamite": 1,
      "skip_go": 100
    },
    "mission10": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "sheep": 1,
      "skip_go": 100
    },
    "mission11": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "uzi": 1,
      "skip_go": 100
    },
    "mission12": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "laser_pistol": 1,
      "skip_go": 100
    },
    "mission13": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "old_woman": 1,
      "skip_go": 100
    },
    "mission14": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "skip_go": 100
    },
    "mission15": {
      "bazooka": 100,
      "grenade": 100,
      "prod": 100,
      "fireball": 2,
      "laser_rifle": 1,
      "skip_go": 100
    },
    "mission16": {
      "teleport": 1,
      "girder": 9,
      "pistol": 9,
      "uzi": 4,
      "minigun": 1,
      "banana_bomb": 1,
      "holy_hand_grenade": 1,
      "firepunch": 2,
      "baseball_bat": 1,
      "low_gravity": 1,
      "jet_pack": 1,
      "bazooka": 6,
      "grenade": 6,
      "laser_rifle": 1,
      "plasma_pistol": 1,
      "gauss_pistol": 2,
      "ultra_scaner": 1,
      "skip_go": 100
    }
  };
}
